import {GlobalDialogConfig} from './global-dialog.config.types';

export const GLOBAL_DIALOG_DEFAULT_CONFIG: <T>(overrides?: Partial<GlobalDialogConfig<T>>) => GlobalDialogConfig<T> = <T>(overrides?: Partial<GlobalDialogConfig<T>>) => {
	const config: GlobalDialogConfig<T> = {
		inputsData: null,
		header: undefined,
		draggable: true,
		resizable: true,
		contentStyle: undefined,
		contentStyleClass: undefined,
		modal: false,
		closeOnEscape: true,
		dismissableMask: false,
		rtl: false,
		closable: true,
		appendTo: undefined,
		breakpoints: undefined,
		styleClass: undefined,
		maskStyleClass: undefined,
		maskStyle: undefined,
		showHeader: false,
		blockScroll: false,
		autoZIndex: true,
		baseZIndex: 0,
		minX: 0,
		minY: 0,
		focusOnShow: true,
		maximizable: false,
		keepInViewport: true,
		focusTrap: true,
		closeAriaLabel: undefined,
		closeTabindex: '-1',
		minimizeIcon: undefined,
		maximizeIcon: undefined,
		onShow: undefined,
		onHide: undefined,
		visibleChange: undefined,
		onResizeInit: undefined,
		onResizeEnd: undefined,
		onDragEnd: undefined,
		onMaximize: undefined,
	};

	/* -------------- apply overrides: -------------- */
	Object.assign(config, overrides);

	/* -------------- validate configs: -------------- */
	config.showHeader = Boolean(config.header) || config.showHeader;
	if (config.modal === true) config.dismissableMask = true;

	/* ------- Drop all undefined properties: ------- */
	Object.keys(config).forEach(key => {
		if (config[key] === undefined) delete config[key];
	});

	return config;
};
